import React, { Fragment, useState, useEffect, useRef } from "react";
import { Form, Row, Col, Input, Button, message } from 'antd';
import { saveStudentInfo, getQuizName } from 'lib'
import isEmail from 'validator/lib/isEmail';
import isEmpty from 'validator/lib/isEmpty';
import TranslatedText from "translations/TranslatedText";
import Title from 'antd/es/typography/Title';
import Paragraph from 'antd/es/typography/Paragraph';
import Text from 'antd/es/typography/Text';
import TwoToneText from 'ReusableComponents/TwoToneText';

function getSubtitleText(quizName) {
  const base = "student.form.submitemail";
  if (quizName.includes('China Quiz')) return base+'.chinaquiz.subtitle';
  if (quizName.includes('Hanzi Game')) return base+'.hanzigame.subtitle';
  return base+'.subtitle';
}

function DefaultInstructions() {
  return (
    <Col span={19}>
      <Text >
        <TranslatedText id="student.form.submitemail.instructions" />
      </Text>
    </Col>
  );
}

function HanziGameInstructions() {
  return (
    <Col span={24}>
      <Text>
        <TranslatedText id="student.form.submitemail.hanzigame.instructions" />
      </Text>
      <br />
      <Text>
        <TranslatedText id="student.form.submitemail.hanzigame.instructions2" />
      </Text>
      <br />
      <Paragraph>
        <TranslatedText id="student.form.submitemail.hanzigame.instructions3" />
      </Paragraph>
    </Col>
  );
}

function ChinaQuizInstructions() {
  return (
    <Col span={22}>
      <Paragraph>
        <TranslatedText id="student.form.submitemail.chinaquiz.instructions" />
      </Paragraph>
      <Text>
        <TranslatedText id="student.form.submitemail.chinaquiz.instructions2" />
      </Text>
    </Col>
  );
}

function getInstructions(quizName) {
  if (quizName.includes('China Quiz')) {
    return ChinaQuizInstructions;
  } else if (quizName.includes('Hanzi Game')) { 
    return HanziGameInstructions;
  } else if (quizName.includes('Hanzi Level')) { 
    return HanziGameInstructions;
  } else {
    return DefaultInstructions;
  }
}


export default function SubmitEmail(props) {
  const {
    onSubmit,
  } = props;
  const [name, setName] = useState('');
  // 1 instead of true fixes bug whereby useEffect can detect a change
  const [nameValid, setNameValid] = useState(1);
  const [email, setEmail] = useState('');
  const [emailValid, setEmailValid] = useState(1);
  const quizName = getQuizName();
  const subtitleText = getSubtitleText(quizName);
  const InstructionsCol = getInstructions(quizName);

  const validateEmail = () => {
    if (isEmail(email)) {
      setEmailValid(true)
    } else {
      setEmailValid(false)
    }

    if (!isEmpty(name)) {
      setNameValid(true)
    } else {
      setNameValid(false)
    }
  }

  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      if (!isEmpty(email) && !isEmpty(name) && emailValid && nameValid) {
        saveStudentInfo(name, email);
        onSubmit();
      }
    }
    return () => { isMounted = false }; // prevent state changes after unmount
  }, [emailValid, nameValid])

  return (
    <Row type="flex" justify="center"
         align="top"
         style={{ height: "100vh", marginTop: '0vh', }}
     >
      <Col>
        <Row style={{ marginBottom: '2%', fontFamily: 'AvenirNextLTPro-Bold', }}
             type="flex" justify="center" align="middle"
        >
          <Col>
            <TwoToneText text={quizName} />
          </Col>
        </Row>
        <Row style={{ marginBottom: '3%', fontFamily: 'AvenirNextLTPro-Bold', }} type="flex" justify="center" align="middle">
          <Col>
            <Text style={{ color: 'black', fontSize: '2.25em', fontWeight: '600', }}>
              <TranslatedText id={subtitleText} />
            </Text>
          </Col>
        </Row>
        <Row style={{ marginBottom: '3%', fontFamily: 'AvenirNextLTPro-Regular', }} type="flex" justify="center" align="middle">
          <InstructionsCol />
        </Row>
        <Form>
          <Input.Group>
            <Row style={{ marginBottom: '2%' }} type="flex" justify="center" align="middle">
              <Col>
                <Paragraph style={{ color: 'black', fontFamily: 'AvenirNextLTPro-Regular', fontSize: '1.5em' }}><TranslatedText id="student.form.submitemail.label" /></Paragraph>
              </Col>
            </Row>
            <Row type="flex" justify="center" align="middle">
              <Col span={16}>
                <Form.Item validateStatus={nameValid ? "success" : "error"}>
                  <Input addonBefore="name" placeholder="john doe"
                         onChange={(event) => setName(event.target.value)}
                         value={name}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row type="flex" justify="center" align="middle">
              <Col span={16}>
                <Form.Item validateStatus={emailValid ? "success" : "error"}>
                  <Input.Search placeholder="john.doe@gmail.com"
                          addonBefore="email"
                          onPressEnter={validateEmail}
                          onChange={(event) => setEmail(event.target.value)}
                          value={email}
                          enterButton="Submit"
                          onSearch={validateEmail}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Input.Group>
        </Form>
      </Col>
    </Row>
  );
} 
